export default class ErrorFormResponse {
  level?: string[]
  common?: string[]
  email?: string[]
  firstname?: string[]
  lastname?: string[]
  password?: string[]
  organization?: string[]
  jobRoles?: string[]
  phone?: string[]
  mobilePhone?: string[]
  countryRegion?: string[]
  address?: string[]
  city?: string[]
  state?: string[]
  cityState?: string[]
  zipCode?: string[]
  agreeCheck?: string[]
  recaptcha?: string[]
  updateDttm?: string[]
  urlParam?: string[]
  currentPassword?: string[]
  newPassword?: string[]
  confirmPassword?: string[]
  productCategory?: string[]
  field?: string[]
  url?: string[]
  title?: string[]
  contentType?: string[]
  fileType?: string[]
  fileSize?: string[]
  newEmail?: string[]
  confirmEmail?: string[]
  authCode?: string[]
  department?: string[]
  token?: string[]
  forDownload?: string[]
}
